import { css, keyframes } from '@emotion/react';

import type { CSSProperties } from 'react';

interface Props {
  /** true: 화면 전체(fixed) overlay + 반투명 backdrop. false: 부모 기준(absolute). */
  fullScreen?: boolean;
  /** SVG 크기. 미지정 시 기본 124x124 (svg viewBox). */
  size?: CSSProperties['width'];
}

/**
 * 회전 Spinner — npo-backoffice 디자인 이식 (Tailwind → emotion).
 * @description 대시보드 등 첫 진입 로딩 표시. fullScreen 모드는 layout 위 backdrop overlay.
 */
function Spinner({ fullScreen = false, size = 62 }: Props) {
  return (
    <div css={[styles.container(fullScreen)]}>
      <div css={styles.spin}>
        <svg
          fill="none"
          height="124"
          style={{ height: size, width: size }}
          viewBox="0 0 156 156"
          width="124"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="78" cy="78" r="57" stroke="#1677ff" strokeOpacity="0.25" strokeWidth="14" />
          <path
            d="M76.5234 20.9833C91.4343 20.8786 105.776 26.7853 116.392 37.4039C127.009 48.0226 133.031 62.4834 133.134 77.6052"
            stroke="url(#paint0_linear_354_3449)"
            strokeDasharray="4 4"
            strokeLinecap="round"
            strokeWidth="14"
          />
          <defs>
            <linearGradient
              id="paint0_linear_354_3449"
              gradientUnits="userSpaceOnUse"
              x1="125.45"
              x2="27.6854"
              y1="106.776"
              y2="50.4202"
            >
              <stop stopColor="#1677ff" />
              <stop offset="0.755208" stopColor="#1677ff" stopOpacity="0.01" />
              <stop offset="1" stopColor="#1677ff" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
}

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const styles = {
  container: (fullScreen: boolean) => css`
    position: ${fullScreen ? 'fixed' : 'absolute'};
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9000;
    background: ${fullScreen ? 'rgba(255, 255, 255, 0.5)' : 'transparent'};
    pointer-events: ${fullScreen ? 'auto' : 'none'};
  `,

  spin: css`
    animation: ${spin} 1s linear infinite;
  `,
};

export default Spinner;
